import * as fromDatatype from '../datatype-library/index';

export interface bl_sch_crontab_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  trigger_time: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_sch_crontab_event_RowClass implements bl_sch_crontab_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  trigger_time: fromDatatype.TimestampTzDatatypeInterface;
}
